<template lang="pug">
div

  section.full__video
    .intro__content.intro__content--mobile
      img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/persecond/persecond@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecond.png 1x')
      h2 Create beautiful time lapses effortlessly
      .btn__group.btn__group--splash.btn__group--persecond
        download-trial-button(
          product='persecond',
          classes='btn btn--blue',
          copy='Download free trial'
        )
        get-plan(
          classes='btn btn--white btn__splash',
          isPersecond='true'
        )

    .fluid__video
      .intro__content.intro__content--desktop
        img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/persecond/persecond@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecond.png 1x')
        h2 Create beautiful time lapses effortlessly
        .btn__group.btn__group--persecond
          download-trial-button(
            product='persecond',
            classes='btn btn--blue',
            copy='Download free trial'
          )
          get-plan(
            classes='btn btn--white',
            isPersecond='true'
          )
      iframe(data-src='https://media.flixel.com/cinemagraph/d2dkm41ovvcksq2yf71v?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/Lensofadventure/') Lensofadventure

  brands

  section
    .product__section.product__section--reverse
      .product__section--content
        .productItem__title
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x')
          h2
            | Persecond
            span for macOS
        .productItem__desc
          p Make life move fast, even faster. Use Persecond to easily transform your images into a unique time lapse.
          .btn__group
            download-trial-button(
              product='persecond',
              classes='btn btn--blue',
              copy='Download free trial')
            get-plan(
              classes='btn btn--white',
              isPersecond='true'
            )
      .product__section--image#persecondImage
        img.lazy.persecondImage(data-srcset='https://cdn.flixel.com/static/static-web/products/persecond/persecondproduct@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecondproduct.png 1x')

  section
    .product__section
      .product__section--video
        .video__text
          h2 Mesmerizing Time Lapses in 3 Steps
          p Persecond makes time lapse creation simple. Transform your image set into a cinematic time lapse in just 3 steps. 
        video.persecond.video(width='auto', height='auto', loop autoplay playsinline)
          source(src='https://cdn.flixel.com/static/static-web/products/persecond/persecond.mp4', type='video/mp4')
        .video__details
          .detail
            .detail--title
              h3 Be the Director
            .detail--desc
              p Capture your image set. Think about how each element, from motion to framing will influence your story. When you’re happy with it, import your image set into Persecond. 
          .detail
            .detail--title
              h3 Shape Your Story
            .detail--desc
              p Edit your time lapse to tell your story in the best way possible. Select the in and out points of your time lapse, set the movement to forwards or backwards and pick the overall speed so that the motion is just right.
          .detail
            .detail--title
              h3 Share It
            .detail--desc
              p It’s time for the world to see your beautiful time lapse. Export in broadcast quality using ProRes. Share it on social, or use your time lapse in a larger video production. You can even create a cinemagraph out of your time lapse. Show your view of life, perfectly sped up, in no time at all.

  section.product__section.product__section--carousel
    .carousel__item.fluid__video.carousel__item--wide
      iframe(data-src='https://media.flixel.com/cinemagraph/d1qb0eqtqxu8l6b6rf54?hd=true' allow='autoplay')
    .carousel__item.fluid__video.carousel__item--thin
      iframe(data-src='https://media.flixel.com/cinemagraph/qu9t351e6la6w39u7j7s?hd=true' allow='autoplay')
    .carousel__item.fluid__video.carousel__item--wide
      iframe(data-src='https://media.flixel.com/cinemagraph/pm1yda3zkbjvvfpla1jx?hd=true' allow='autoplay')
    .carousel--mobile
      iframe(data-src='https://media.flixel.com/cinemagraph/6gtn5x2dvh413czlixth?hd=true' allow='autoplay')

  section.carousel__attributions
    h2 Check out more by the artists featured here.
    .attributions
      a(href='https://flixel.com/aaroncoury/' target="_blank") aaroncoury
      a(href='https://flixel.com/savageian/' target="_blank") savageian
      a(href='https://flixel.com/robertlendvai/' target="_blank") robertlendvai
    .attributions--mobile
      a(href='https://flixel.com/CinePix/' target="_blank") CinePix

  section
    .product__section
      .product__section--cta
        .productItem__title--cta
          h2 Create Time Lapse Cinemagraphs with Persecond and Cinemagraph Pro
        .productItem__desc--cta
          p Transform time lapses created with Persecond into thumb-stopping cinemagraphs using Flixel Cinemagraph Pro for macOS and iOS. Get inspired by time lapse cinemagraphs created by the Flixel Community.
          .btn__group
            a.btn.btn--blue(href='/cinemagraphs/timelapse') View Gallery

  section.flixelPlan__section
    .flixelPlan__container
      h1 Choose a plan that’s right for you
      p Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform.
      .btn__group
        get-plan(
          classes='btn btn--white',
          isPersecond='true'
        )

  section
    .product__section
      .product__section--specs
        h2 System Requirements
        p macOS 10.12.2 Sierra or later, 4GB of RAM (8GB recommended for 4K), Metal-capable graphics card
          a(href='https://support.apple.com/en-us/HT205073')
            | (Macs from 2012 or later),
          |  256MB of VRAM (1GB recommended for 4K), 1GB of disk space.
  // Rich Card
  script(
    type="application/ld+json" 
    ) {{ this.$metaInfo}}
</template>

<script>
import Brands from 'components/Brands.vue';
import getPlan from 'components/getPlan.vue';
import downloadTrialButton from 'components/downloadTrialButton.vue';
import downloadTrialModal from 'components/downloadTrial.vue';
import productmixin from './productmixin.vue';

export default {
  name: 'mac-fps',
  metaInfo() {
    return {
      title: 'Persecond for macOS | Flixel',
      meta: [
        {
          'property': 'image',
          'content': 'https://cdn.flixel.com/static/static-web/Persecond.png',
        },
        {
          'property': 'description',
          'content': 'The easiest app to create timelapse videos. Combine Persecond with Cinemagraph Pro to create timelapse cinemagraphs.',
        },
        {
          'property': 'richcard',
          'content': '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Persecond for macOS","description":"The easiest app to create timelapse videos. Combine Persecond with Cinemagraph Pro to create timelapse cinemagraphs.","image":["https://cdn.flixel.com/static/static-web/Persecond_1_1.png","https://cdn.flixel.com/static/static-web/Persecond_4_3.png","https://cdn.flixel.com/static/static-web/Persecond_16_9.png"],"downloadUrl":"https://flixel.com/","operatingSystem":"iOS 11.0 and higher","storageRequirements":"100 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.2","bestRating":"5.0","ratingCount":"189"},"offers":{"@type":"Offer","price":"4.99","priceCurrency":"USD"}}',
        },
      ],
      script: [
        {
          innerHTML: '{ "@context":"https://schema.org","@type":"SoftwareApplication","name":"Persecond for macOS","description":"The easiest app to create timelapse videos. Combine Persecond with Cinemagraph Pro to create timelapse cinemagraphs.","image":["https://cdn.flixel.com/static/static-web/Persecond_1_1.png","https://cdn.flixel.com/static/static-web/Persecond_4_3.png","https://cdn.flixel.com/static/static-web/Persecond_16_9.png"],"downloadUrl":"https://flixel.com/","operatingSystem":"iOS 11.0 and higher","storageRequirements":"100 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.2","bestRating":"5.0","ratingCount":"189"},"offers":{"@type":"Offer","price":"4.99","priceCurrency":"USD"}}',
          type: 'application/ld+json',
        },
      ],
    };
  },
  data() {
    return {
      modalShow: false,
      ytVideo: '',
      modalProduct: false,
    };
  },
  mounted() {
    $(window).ready(function () {
      $(window).scrollTop(0);
    });
  },
  mixins: [productmixin],
  components: {
    'Brands': Brands,
    'get-plan': getPlan,
    'download-trial-button': downloadTrialButton,
    'download-trial-modal': downloadTrialModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/products/mac-fps.vue